<template>
  <div v-show="this.events.length > 0" class="bg-white mb-5">
    <h2 class="text-center uppercase mb-3 font-medium leading-tight">Our Events</h2>
    <div class="border-b py-3"  v-for="myEvent in events">
      <div class="flex items-center">
        <div class="flex items-start justify-center w-1/6 px-0">
          <div>
            <div class="flex justify-center items-center flex-col">
              <div class="mb-0 mr-2 text-blue font-medium block text-4xl block">{{myEvent.beginDay}}</div>
              <div class="mb-0 mr-2 text-blue font-normal block uppercase text-base block">{{myEvent.beginMonth}}</div>
            </div>
          </div>
        </div>
        <div class="pl-3">
          <div class="flex flex-col space-y-1">
            <span class="text-sm text-black font-medium">{{myEvent.title}}</span>
            <div class="flex flex-row items-center">
                                    <span class="mb-0 mr-1">
                                        <i class="fas fa-clock text-gray-600 text-sm"></i>
                                    </span>
              <span class="mb-0 relative text-sm">{{myEvent.timeRange}}</span>
            </div>
            <div class="flex flex-row">
                                    <span class="mb-1 mr-1">
                                        <i class="fas fa-map-marker text-gray-600 text-sm"></i>
                                    </span>
              <span class="mb-0 relative text-sm"><a class="text-pink hover:text-pink-600" :href="myEvent.googleMapUrl" target="_blank">
                <span class="block">{{myEvent.address}}</span> <span v-show="myEvent.city" class="block">{{myEvent.city}}, {{myEvent.state}} {{myEvent.zip}}</span></a></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CampaignEventDisplayLegacy',
    props: {
      campaignId: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        events: [],
      }
    },
    created() {
      axios.get('/campaign/events/'+this.campaignId)
          .then(response => {
            this.events = response.data
          })
    },
  }
</script>


